// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".change-icon[data-v-3c818e53]{margin-top:50px;text-align:center}", ""]);
// Exports
module.exports = exports;
